(function () {
  var STORAGE_KEY = 'pippa-welcome-popup-dismissed';
  var popup = document.getElementById('welcome-popup');
  if (!popup) return;

  var alreadyDismissed = localStorage.getItem(STORAGE_KEY);
  var justSubmitted = popup.querySelector('.welcome-popup__success');

  function close() {
    popup.setAttribute('hidden', '');
    document.body.classList.remove('welcome-popup-open');
    localStorage.setItem(STORAGE_KEY, '1');
  }

  function open() {
    popup.removeAttribute('hidden');
    document.body.classList.add('welcome-popup-open');
  }

  popup.querySelectorAll('[data-welcome-popup-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !popup.hasAttribute('hidden')) close();
  });

  if (justSubmitted) {
    // Show immediately with the success message after the page reloads
    // from the form POST, then remember not to show it again.
    open();
    localStorage.setItem(STORAGE_KEY, '1');
  } else if (!alreadyDismissed) {
    setTimeout(open, 3000);
  }
})();
